var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    transform: "rotate(90 11 11)",
    stroke: "#000450"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000450",
    d: "M10.5 16.5V5.042M16.959 10.542L10.771 16.5l-6.187-5.958"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIGZpbGw9Im5vbmUiPgogIDxjaXJjbGUgY3g9IjExIiBjeT0iMTEiIHI9IjEwLjUiIHRyYW5zZm9ybT0icm90YXRlKDkwIDExIDExKSIgc3Ryb2tlPSIjMDAwNDUwIi8+CiAgPHBhdGggc3Ryb2tlPSIjMDAwNDUwIiBkPSJNMTAuNSAxNi41TDEwLjUgNS4wNDIiLz4KICA8cGF0aCBkPSJNMTYuOTU5IDEwLjU0MTZMMTAuNzcxNSAxNi41TDQuNTgzOTggMTAuNTQxNiIgc3Ryb2tlPSIjMDAwNDUwIi8+Cjwvc3ZnPg==";
export { SvgFileDownload as ReactComponent };